export default __webpack_public_path__ + "static/md-36526cb537922a173670c7368e606e05.svg";